import { Box, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';

interface BannerProps {
  message: string;
  link?: string;
  linkLabel?: string;
}
export const Banner = ({ message, link, linkLabel }: BannerProps) => {
  return (
    <Box
      sx={{
        bgcolor: 'warning.dark',
        color: 'common.white',
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        justifyContent: 'center',
        flexWrap: 'wrap',
        px: 3,
        py: 1,
      }}
    >
      <Typography align="center" fontWeight="Bold">
        {message}
      </Typography>
      {!!(link && linkLabel) && (
        <Button
          component={Link}
          to={link}
          sx={{ height: 'auto', py: 0.75, px: 1.5, fontWeight: 'Bold' }}
          size="small"
          variant="light"
        >
          {linkLabel}
        </Button>
      )}
    </Box>
  );
};
